import { tokens } from "../../theme";
import * as React from "react";
import TextField from "@mui/material/TextField";
import {
    Grid,
    IconButton,
    Typography,
    useTheme,
} from "@mui/material"


const ChangePassword = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    //const navigate = useNavigate();

    return (
        <Grid
            container
            direction={"column"}
            p={"0 2.5%"}
        >



            {/* Header */}
            <Grid item>
                <Grid container direction={"row"} alignItems={"center"} spacing={2}>
                    <Grid item>
                        <IconButton href="/Dashboard" width={12}><img src={"../../assets/common/Back.svg"} width={12} /></IconButton>
                    </Grid>
                    <Grid item>
                        <Typography color={colors.grey[100]} fontWeight={"600"} variant="h3">
                            Change Password
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
            {/* Header */}


            <Grid item>

                <Grid
                    container
                    p={3}
                    direction={"column"}
                    mt={2}
                    justifyContent={"center"}
                    sx={{
                        background: colors.grey[900],
                        borderRadius: "12px"
                    }}
                >
                    <Grid item>
                        <TextField
                            margin="dense"
                            label="Current Password"
                            type="text"
                            name="companyName"
                            fullWidth
                            inputProps={{ style: { height: "20px" } }}
                            helperText={"Please enter your current Password"}
                        />
                    </Grid>

                    <Grid item>
                        <TextField
                            margin="dense"
                            label="Current Password"
                            type="text"
                            name="companyName"
                            fullWidth
                            inputProps={{ style: { height: "20px" } }}
                            helperText={"Please enter your current Password"}
                        />
                    </Grid>


                
                </Grid>
                </Grid>

        </Grid>
                

    );
};

export default ChangePassword;
